import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION8: PdfComponent = {
  type: 'section',
  id: 's8',
  title: '8. Legal Challenges, Complaints, Liabilities, Fraud & Suspension',
  content: [
    {
      type: 'bulletList',
      id: 's8bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Subscriber undertakes to ensure that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "The Subscriber shall have responsibility for dealing with queries, disputes, or complaints made by any Customer in respect of the Subscriber's obligations under this Agreement and/or in relation to the Permitted Goods and Services or the contract between the Subscriber and the Customer.",
              },
              {
                copy: 'Where a lender (acting through Kanda or otherwise) has responsibility for dealing with a Customer complaint in relation to the Credit Agreement, the Subscriber and Kanda shall promptly pass on any such complaints to the appropriate lender. This shall be done without undue delay and in any event within five (5) Business Days of receiving the complaint.',
              },
              {
                copy: 'Where a complaint is initially handled by a lender or Kanda but it becomes apparent that the matter falls within the responsibility of the Subscriber, then upon request from Kanda or the lender, the Subscriber shall promptly use its best endeavours to take over management of the complaint. Where full responsibility transfer is not possible, the Subscriber shall use best endeavours to assist in resolving the complaint.',
              },
              {
                copy: 'Kanda and the Subscriber shall provide all reasonable assistance to any lender in defending any claim threatened or made by a Customer in connection with the credit arrangement or underlying sale.',
              },
              {
                copy: 'In all circumstances, Kanda and the Subscriber shall, in relation to any disputes or complaints for which they have responsibility:',
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'notify the relevant party (Kanda or the lender, as applicable) as soon as practicable upon receipt of a dispute or complaint, and keep them informed of all material developments;',
                    },
                    {
                      copy: 'respond to any such dispute or complaint as soon as reasonably practicable and in accordance with Applicable Laws;',
                    },
                    {
                      copy: 'use all reasonable endeavours to resolve the dispute or complaint in line with Applicable Laws and the contract between the Subscriber and the Customer;',
                    },
                    {
                      copy: 'preserve all relevant documentary evidence that may be required in connection with any proceedings, and make contemporaneous notes of any material verbal discussions with the Customer or third parties;',
                    },
                    {
                      copy: 'keep a record of all complaints received, including outcomes and any redress or payments made to the Customer in resolution of the complaint;',
                    },
                    {
                      copy: "complaint and promptly provide Kanda with this record, including a copy of any final response letter, on a regular basis or upon Kanda's reasonable request; and",
                    },
                    {
                      copy: 'promptly notify Kanda of any complaints received and/or any decisions made by the Financial Ombudsman Service against the Subscriber.',
                    },
                  ],
                },
              },
              {
                copy: "Where a lender (via Kanda or otherwise) has received a dispute or complaint from a Customer which is related to the actions or inactions of the Subscriber, and the lender and the Subscriber fail to resolve the dispute or complaint within five (5) weeks of it being made (whether orally or in writing), the Subscriber acknowledges and agrees that the lender may settle the complaint on such terms as it sees fit in its sole and absolute discretion. The Subscriber shall indemnify Kanda against the costs Kanda incurs under any Broker Agreement in relation to Kanda's obligations to the lender for the costs of settling such complaint, as well as any ancillary costs (including, without limitation, legal costs reasonably and properly incurred), and Kanda may set off such costs against any monies owed to the Subscriber in accordance with clause 9 (Set-Off).",
              },
              {
                copy: "The Subscriber shall immediately notify Kanda if it becomes the subject of any investigation by any regulator, including but not limited to HM Revenue & Customs, the Information Commissioner's Office, or any Trading Standards officer. In addition, the Subscriber shall notify Kanda if any such authority takes enforcement action against the Subscriber, or if any complaint is made to any applicable regulator regarding the Subscriber's activities relating to the provision of credit, or if the Subscriber breaches any of the terms of this Agreement.",
              },
              {
                copy: 'Kanda shall have the right to terminate this Agreement on termination of any Broker Agreement to which this Agreement relates, for any reason, by providing written notice to the Subscriber.',
              },
            ],
          },
        },
      ],
      prefix: '8',
    },
  ],
};
